// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__37gsO","obliqueLineWrap":"membershipbadge_obliqueLineWrap__lCTLP","obliqueLine":"membershipbadge_obliqueLine__2zlQi"};